/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Deactivate_HintInputs */

const vi_irrigation_schedule_deactivate_hint = /** @type {(inputs: Irrigation_Schedule_Deactivate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu sẽ ngưng áp dụng lịch này (cấu hình vẫn được giữ). Các phiên chưa chạy của lịch này bị bỏ.`)
};

/**

* @param {Irrigation_Schedule_Deactivate_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_deactivate_hint = /** @type {((inputs?: Irrigation_Schedule_Deactivate_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Deactivate_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_deactivate_hint(inputs)
});